import styled from 'styled-components';
import { TextButton, token } from '@zillow/constellation';

export const AdjustPriceButton = styled(TextButton)`
  font-weight: bold;
  color: ${token('colors.brand')};
`;

export const SupStyles = styled.sup`
  vertical-align: baseline;
`;
